<div class="ease-in-out duration-500 text-gray-400 focus-within:text-bey-black">
  <label *ngIf="label" class="block text-[#242729] lg:leading-6 text-sm font-light" [ngClass]="classList?.['label']">{{
    label
  }}</label>
  <div getElementId getElementIdDescription="country-selector-dropdown-component" class="w-full flex relative">
    <div
      class="fixed h-full w-full top-0 inset-0"
      (click)="toggleFocus(true)"
      *ngIf="focused && !(readonly || codeInputReadonly)"></div>
    <div class="flex gap-2 w-full">
      <div
        class="flex relative rounded-md"
        [ngClass]="{
          'cursor-pointer': !(readonly || codeInputReadonly || disabled),
          'bg-gray-350': focused && !(readonly || codeInputReadonly || disabled),
          'bg-gray-200': !focused && !(readonly || codeInputReadonly),
          'hover:bg-gray-300': !focused && !(readonly || codeInputReadonly || disabled),
          'bg-transparent': !focused && (readonly || codeInputReadonly) && !disabled,
        }">
        <div class="flex gap-1 px-2 w-full">
          <div>
            <!--
              TODO: remove (click) and (blur) and use of `codeInputReadOnly`
              when Uganda is not the only supported country in production #ugandaOnly
            -->
            <input
              size="4"
              tabindex="1"
              type="text"
              name="password"
              autocomplete="off"
              class="focus:outline-none text-sm py-2 bg-transparent text-center font-medium"
              [ngClass]="{
                'text-gray-300 placeholder:text-gray-300': disabled,
                'text-gray-800 placeholder:text-gray-800': !disabled,
                'cursor-pointer': !(readonly || codeInputReadonly || disabled),
              }"
              [readOnly]="true"
              [value]="inputFieldValue"
              (input)="updateInputVal($event)"
              (focusin)="!(readonly || codeInputReadonly || disabled) && toggleFocus()"
              (keydown)="jumpToList($event)"
              (click)="codeInputClicked.emit()"
              (blur)="codeInputBlur.emit()"
              placeholder="+00"
              getElementId
              getElementIdDescription="country-selector-input-field"
              #codeInput />
          </div>
          <div
            class="flex items-center w-3"
            *ngIf="!(readonly || codeInputReadonly)"
            (click)="!disabled && toggleFocus()">
            <img
              [src]="
                disabled
                  ? 'assets/images/down_arrow_for_select_disabled.svg'
                  : 'assets/images/down_arrow_for_select.svg'
              "
              alt="select arrow icon"
              class="w-10"
              [ngClass]="{ 'rotate-180': focused && !(readonly || codeInputReadonly) }" />
          </div>
        </div>
      </div>
      <div class="flex-1">
        <input
          getElementId
          getElementIdDescription="phone"
          type="number"
          [placeholder]="placeholder"
          class="outline-none text-gray-800 placeholder:text-gray-300 text-sm w-full p-2"
          (input)="phoneInputHandler($event)"
          [disabled]="disabled"
          (blur)="onBlur()"
          [readOnly]="readonly"
          [ngClass]="{
            'bg-white border-solid focus:border-yellow-800 hover:border-gray-800 disabled:border-gray-300': !readonly,
            'border rounded-md focus:border-[1.5px] hover:border-[1.5px] focus:-m-[0.5px] hover:-m-[0.5px] disabled:border':
              !readonly,
            'bg-transparent': readonly || transparent,
            'border-gray-800': !displayError,
            'border-bey-red': displayError
          }"
          min="0"
          NumberInputOnly />
      </div>
    </div>
    <div
      class="absolute top-8 left-0 bg-white w-[236px] transition-all ease-in-out duration-300 rounded-md menu"
      [ngClass]="focused && !(readonly || codeInputReadonly) ? 'opacity-1 z-100' : '-z-1 opacity-0 '"
      getElementId
      getElementIdDescription="country-selector-dropdown-menu">
      <ul class="unstyled">
        <cdk-virtual-scroll-viewport appendOnly itemSize="50" class="viewport">
          <li
            class="flex px-2.5 py-1.5 items-center transition ease-in-out duration-500 hover:bg-blue-100 cursor-pointer focus:outline-1 h-12"
            *cdkVirtualFor="let country of options; let i = index; let isLast = last"
            (click)="selectCountry(country)"
            (keydown)="handleKey($event, country)"
            #countryOption
            [attr.tabIndex]="i"
            [ngClass]="{ 'bg-[#CCE4F1]': value?.value === country.value, 'border-b': !isLast }"
            getElementId
            [getElementIdDescription]="'country-option ' + country.isoCode">
            <img
              width="24"
              height="24"
              class="flag"
              [src]="
                country.isoCode
                  ? 'https://flagcdn.com/' + country.isoCode?.toLowerCase() + '.svg'
                  : '/assets/images/white-flag.png'
              "
              [alt]="country.label"
              loading="lazy" />
            <span class="font text-gray-600 text-sm leading-[14px] flex items-start"
              ><span class="font-bold mr-4"> {{ country.value }} </span> {{ country.label }}</span
            >
          </li>
        </cdk-virtual-scroll-viewport>

        <li
          class="flex py-1.5 pt-3 rounded items-center transition ease-in-out duration-500 hover:bg-blue-100 cursor-pointer"
          (click)="clear()">
          <img src="assets/logos/cross-modal.svg" width="12" height="12" alt="clear" class="mx-4" />
          <span class="font text-gray-600 text-sm leading-[14px]">Clear</span>
        </li>
        <li class="pb-[15px]"></li>
      </ul>
    </div>
  </div>
  <!-- TODO: remove this when Uganda is not the only supported country in production #ugandaOnly -->
  <bey-field-error-message
    *ngIf="ugandaOnlyError"
    [displayError]="true"
    errorMessage="We are currently only available in Uganda">
  </bey-field-error-message>

  <!-- TODO: remove use of `ugandaOnlyError` when Uganda is not the only supported country in production #ugandaOnly -->
  <bey-field-error-message
    *ngIf="!hideValidationFeedback && !ugandaOnlyError"
    [displayError]="displayError"
    [errorMessage]="errorMessage">
  </bey-field-error-message>
</div>
